import { CSSProperties } from 'react';
import { t } from '@ankr.com/common';

import { ConnectionType } from 'modules/chains/constants';

export const getCodeSnippetTitle = (type: ConnectionType) => {
  switch (type) {
    case ConnectionType.HTTP:
      return t(
        'chain-item.get-started.connection-snippet.connection-types.http',
      );

    case ConnectionType.WSS:
      return t(
        'chain-item.get-started.connection-snippet.connection-types.wss',
      );

    default:
      return '';
  }
};

export const overridenViewStyle: CSSProperties = {
  overflow: 'scroll hidden',
  position: 'relative',
};

export const overridenThumbStyle: CSSProperties = {
  backgroundColor: '#161a1d',
  borderRadius: 6,
};
